const envOrDefault = (value, fallback = '') => {
  if (value === undefined || value === null) {
    return fallback;
  }

  const normalized = String(value).trim();
  if (!normalized || normalized.toLowerCase() === 'null' || normalized.toLowerCase() === 'undefined') {
    return fallback;
  }

  return normalized;
};

const lmsBaseUrl = envOrDefault(process.env.LMS_BASE_URL, 'http://local.openedx.io').replace(/\/$/, '');

let sessionCookieDomain = envOrDefault(process.env.SESSION_COOKIE_DOMAIN, '');
if (!sessionCookieDomain) {
  try {
    sessionCookieDomain = new URL(lmsBaseUrl).hostname;
  } catch {
    sessionCookieDomain = 'local.openedx.io';
  }
}

const configuration = {
  LMS_BASE_URL: lmsBaseUrl,
  LOGIN_URL: envOrDefault(process.env.LOGIN_URL, `${lmsBaseUrl}/login`),
  LOGOUT_URL: envOrDefault(process.env.LOGOUT_URL, `${lmsBaseUrl}/logout`),
  SITE_NAME: envOrDefault(process.env.SITE_NAME, 'Farmacia Clinica'),
  LOGO_URL: envOrDefault(process.env.LOGO_URL, `${lmsBaseUrl}/theming/asset/images/logo.png`),
  REFRESH_ACCESS_TOKEN_ENDPOINT: envOrDefault(
    process.env.REFRESH_ACCESS_TOKEN_ENDPOINT,
    `${lmsBaseUrl}/login_refresh`,
  ),
  // Cookies related configs
  SESSION_COOKIE_DOMAIN: sessionCookieDomain,
  USER_RETENTION_COOKIE_NAME: process.env.USER_RETENTION_COOKIE_NAME || '',
  // Features
  DISABLE_ENTERPRISE_LOGIN: process.env.DISABLE_ENTERPRISE_LOGIN || '',
  ENABLE_AUTO_GENERATED_USERNAME: process.env.ENABLE_AUTO_GENERATED_USERNAME === 'true',
  ENABLE_DYNAMIC_REGISTRATION_FIELDS: process.env.ENABLE_DYNAMIC_REGISTRATION_FIELDS || false,
  ENABLE_PROGRESSIVE_PROFILING_ON_AUTHN: process.env.ENABLE_PROGRESSIVE_PROFILING_ON_AUTHN || false,
  ENABLE_POST_REGISTRATION_RECOMMENDATIONS: process.env.ENABLE_POST_REGISTRATION_RECOMMENDATIONS || false,
  MARKETING_EMAILS_OPT_IN: process.env.MARKETING_EMAILS_OPT_IN || '',
  SHOW_CONFIGURABLE_EDX_FIELDS: process.env.SHOW_CONFIGURABLE_EDX_FIELDS || false,
  SHOW_REGISTRATION_LINKS: process.env.SHOW_REGISTRATION_LINKS !== 'false',
  ENABLE_IMAGE_LAYOUT: process.env.ENABLE_IMAGE_LAYOUT || false,
  // Links
  ACTIVATION_EMAIL_SUPPORT_LINK: process.env.ACTIVATION_EMAIL_SUPPORT_LINK || null,
  AUTHN_PROGRESSIVE_PROFILING_SUPPORT_LINK: process.env.AUTHN_PROGRESSIVE_PROFILING_SUPPORT_LINK || null,
  LOGIN_ISSUE_SUPPORT_LINK: process.env.LOGIN_ISSUE_SUPPORT_LINK || null,
  PASSWORD_RESET_SUPPORT_LINK: process.env.PASSWORD_RESET_SUPPORT_LINK || null,
  POST_REGISTRATION_REDIRECT_URL: process.env.POST_REGISTRATION_REDIRECT_URL || '',
  PRIVACY_POLICY: process.env.PRIVACY_POLICY || null,
  SEARCH_CATALOG_URL: process.env.SEARCH_CATALOG_URL || null,
  TOS_AND_HONOR_CODE: process.env.TOS_AND_HONOR_CODE || null,
  TOS_LINK: process.env.TOS_LINK || null,
  // Base container images
  BANNER_IMAGE_LARGE: process.env.BANNER_IMAGE_LARGE || '',
  BANNER_IMAGE_MEDIUM: process.env.BANNER_IMAGE_MEDIUM || '',
  BANNER_IMAGE_SMALL: process.env.BANNER_IMAGE_SMALL || '',
  BANNER_IMAGE_EXTRA_SMALL: process.env.BANNER_IMAGE_EXTRA_SMALL || '',
  // Recommendation constants
  GENERAL_RECOMMENDATIONS: process.env.GENERAL_RECOMMENDATIONS || '[]',
  // Miscellaneous
  INFO_EMAIL: process.env.INFO_EMAIL || '',
  ZENDESK_KEY: process.env.ZENDESK_KEY,
  ZENDESK_LOGO_URL: process.env.ZENDESK_LOGO_URL,
  ALGOLIA_APP_ID: process.env.ALGOLIA_APP_ID || '',
  ALGOLIA_SEARCH_API_KEY: process.env.ALGOLIA_SEARCH_API_KEY || '',
  AUTHN_MINIMAL_HEADER: process.env.AUTHN_MINIMAL_HEADER
    ? process.env.AUTHN_MINIMAL_HEADER === 'true'
    : true,
};

export default configuration;
